import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import TherapyInsurer from "./TherapyInsurer"
import TherapyAge from "./TherapyAge"
import AddIcon from "@material-ui/icons/Add"
import TherapySlideOld from "./TherapySlideOld"
import AccidentAge from "./AccidentAge"
import AccidentSideCovPrice from "./AccidentSideCovPrice"

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class ChangePriceAccident extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            rowsPerPage: 10,
            page: 0,
            accident_price_id: "",
            selectedCompany: "",
            selectedFranchise: "",
            selectedMainCovarage: "",
            selectedSideCovarage: "",
            selectedJobClass: "",
            selectedCalculation: "",
            accident_price_min_age: "",
            accident_price_max_age: "",
            accident_price_age_percentage: "",
            accident_price_disc: "",
            accident_price_amount: "",
            accident_price_urldesc: "",
            accident_price_desc: "",
            accident_price_deactive: "0",
            company_logo_url: "",
            orderBy: "accident_price_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newPriceAccident: true,
            optionCompany: [],
            optionFranchise: [],
            optionMainCovarage: [],
            optionSideCovarage: [],
            optionJobClass: [],
            optionCalculation: [],
            openDialog: false,
            therapyInsurer: [],
            therapyAges: [],
            therapy_price_baseinsurer_percent: "",
            therapy_price_age_price: "",
            selectedTherapyInsurer: "",
            selectedTherapyAge: "",
            accidentSides: [],
            accidentAges: [],
            accident_price_age_price: "",
            accident_price_age_min: "",
            accident_price_age_max: "",
            accident_price_side_coverage_price: "",
        }
    }

    handleClickOpen = () => {
        this.setState({
            openDialog: true,
        })
    }

    handleClose = () => {
        this.setState({
            openDialog: false,
        })
    }

    handleSlidePriceOldMin = (event) => {
        this.setState({ accident_price_age_min: event })
    }
    handleSlidePriceOldMax = (event) => {
        this.setState({ accident_price_age_max: event })
    }

    handleChangeSlideOldPercent = (event) => {
        this.setState({ accident_price_age_price: event })
    }
    handleChangeSideCoveragePrice = (event) => {
        this.setState({ accident_price_side_coverage_price: event })
    }

    handleMainCovarage = (selectedMainCovarage) => {
        this.setState({ selectedMainCovarage: selectedMainCovarage }, () => {})
    }
    handleSideCovarage = (selectedSideCovarage) => {
        this.setState({ selectedSideCovarage: selectedSideCovarage }, () => {})
    }
    handleJobClass = (selectedJobClass) => {
        this.setState({ selectedJobClass: selectedJobClass }, () => {})
    }
    handleCalculation = (selectedCalculation) => {
        this.setState({ selectedCalculation: selectedCalculation }, () => {})
    }
    handleFranchise = (selectedFranchise) => {
        this.setState({ selectedFranchise: selectedFranchise }, () => {})
    }

    handleCompany = (selectedCompany) => {
        this.setState({ selectedCompany: selectedCompany }, () => {
            this.filterPriceAccident()
        })
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleChangeDeactive = (event) => {
        if (event.target.checked) {
            this.setState({ accident_price_deactive: "0" })
        } else {
            this.setState({ accident_price_deactive: "1" })
        }
    }

    handleTherapyInsurer = (selectedTherapyInsurer) => {
        this.setState({ selectedTherapyInsurer: selectedTherapyInsurer })
    }

    handleChangeTherapyInsurer = (event) => {
        this.setState({ therapy_price_baseinsurer_percent: event })
    }

    handleTherapyAge = (selectedTherapyAge) => {
        this.setState({ selectedTherapyAge: selectedTherapyAge })
    }

    handleChangeTherapyAge = (event) => {
        this.setState({ therapy_price_age_price: event })
    }

    handleSelectRows = (row2) => {
        console.log("angry",row2)
        // this.gettherapyAge(row2.accident_price_id)
        this.getaccidentAge(row2.accident_price_id)
        this.getAccidentPriceSideCov(row2.accident_price_id)




        this.setState(
            {
                accident_price_id: row2.accident_price_id,
                selectedCompany: { value: row2.accident_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                // selectedMainCovarage: { value: row2.accident_price_accident_main_coverage_id, label: row2.accident_main_coverage_name },
                selectedSideCovarage: { value: row2.accident_price_accident_side_coverage_id, label: row2.accident_side_coverage_name },
                selectedJobClass: { value: row2.accident_price_accident_job_class_id, label: row2.accident_job_class_name },
                selectedCalculation: { value: row2.accident_calculation_id, label: row2.accident_calculation_name },
                selectedFranchise: { value: row2.therapy_price_franchise_id, label: row2.therapy_franchise_name },
                accident_price_urldesc: row2.accident_price_urldesc,
                accident_price_desc: row2.accident_price_desc,
                accident_price_disc: row2.accident_price_disc,
                accident_price_amount: row2.accident_price_amount,
                accident_price_min_age: row2.accident_price_min_age,
                accident_price_max_age: row2.accident_price_max_age,
                accident_price_age_percentage: row2.accident_price_age_percentage,
                accident_price_deactive: row2.accident_price_deactive,
                company_logo_url: row2.company_logo_url,
                newPriceAccident: false,
            },
            () => {
                // اگر نیاز به بررسی وضعیت به‌روزرسانی دارید، می‌توانید از console.log در اینجا استفاده کنید
            }
        );
        // console.log(row2.accident_price_fieldcompany_id)

    }



newPriceAccident = (event) => {
        this.setState({
            accident_price_id: "",
            selectedCompany: "",
            selectedFranchise: "",
            // selectedMainCovarage: "",
            selectedSideCovarage: "",
            selectedJobClass: "",
            selectedCalculation: "",
            accident_price_deactive: "0",
            company_logo_url: "",
            accident_price_urldesc: "",
            accident_price_desc: "",
            accident_price_disc: "0",
            accident_price_amount: "0",
            accident_price_min_age: "0",
            accident_price_max_age: "0",
            accident_price_age_percentage: "0",
            newPriceAccident: true,
        })
    }
    componentDidMount() {

        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getPriceAccident()
                        self.getoptionCompany()
                        self.getoptionMainCovarage()
                        self.getoptionSideCovarage()
                        self.getoptionJobClass()
                        self.getoptionCalculation()
                        self.getoptionTherapyInsurer()
                        self.getoptionTherapyAge()

                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }



    getPriceAccident() {
        console.log("hellow")
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                        self.filterPriceAccident()
                    })
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }

        var fd = new FormData()
        fd.append("command", "get_accident_price")

        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }


    deletePriceAccident = () => {
        const { accident_price_id } = this.state
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.handleClose()
        var self = this
        var xhttp = new XMLHttpRequest()


        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.newPriceAccident()
                    self.getPriceAccident()
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_accident_price")
        fd.append("accident_price_id", accident_price_id)

        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }


    gettherapyInsurer(accident_price_id) {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.setState({ therapyInsurer: [] }, () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    // console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ therapyInsurer: arr.data }, () => {})
                    } else if (arr.result === "error") {
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "get_price_baseinsurer")
            fd.append("accident_price_id", accident_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        })
    }

    gettherapyAge(accident_price_id) {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.setState({ therapyAge: [] }, () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ therapyAge: arr.data }, () => {})
                    } else if (arr.result === "error") {
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "get_price_age")
            fd.append("accident_price_id", accident_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        })
    }


    getAccidentPriceSideCov(accident_price_id) {
        // alert(accident_price_id)
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.setState({ accidentSides: [] }, () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ accidentSides: arr.data }, () => {})
                    } else if (arr.result === "error") {
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "get_price_side_cov")
            fd.append("accident_price_id", accident_price_id)
            // fd.append("sideCoverageId", sideCoverageId)

            xhttp.open("POST", `${constants.BASE_URL}/accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        })
    }

    getaccidentAge(accident_price_id) {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.setState({ accidentAges: [] }, () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ accidentAges: arr.data }, () => {})
                    } else if (arr.result === "error") {
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "get_price_age")
            fd.append("accident_price_id", accident_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        })
    }



    getoptionCompany = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({
                            value: arr.data[k].fieldcompany_id,
                            label: arr.data[k].company_name,
                            logo: arr.data[k].company_logo_url,
                        })
                    }
                    console.log("kkkk",Company)
                    self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                        self.filterPriceAccident()
                    })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_fieldcompany")
        fd.append("fieldinsurance", "accident_ins")
        xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
        xhttp.send(fd)
    }

    getoptionTherapyInsurer = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].therapy_baseinsurer_id, label: arr.data[k].therapy_baseinsurer_name })
                    }
                    self.setState({ optionTherapyInsurer: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_therapy_baseinsurer")
        xhttp.open("POST", `${constants.BASE_URL}/therapy`)
        xhttp.send(fd)
    }

    getoptionTherapyAge = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].therapy_age_id, label: arr.data[k].therapy_age_name })
                    }
                    self.setState({ optionTherapyAge: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_therapy_age")
        xhttp.open("POST", `${constants.BASE_URL}/therapy`)
        xhttp.send(fd)
    }

    getoptionMainCovarage = () => {

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)

                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].accident_main_coverage_id, label: arr.data[k].accident_main_coverage_name })
                    }
                    self.setState({ optionMainCovarage: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_accident_main_coverage")
        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.send(fd)
    }
    getoptionSideCovarage = () => {

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)

                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].accident_side_coverage_id, label: arr.data[k].accident_side_coverage_name })
                    }
                    self.setState({ optionSideCovarage: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_accident_side_coverage")
        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.send(fd)
    }
    getoptionJobClass = () => {

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)

                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].accident_job_class_id, label: arr.data[k].accident_job_class_name })
                    }
                    self.setState({ optionJobClass: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()

        fd.append("command", "get_accident_job_class")
        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.send(fd)
    }
    getoptionCalculation = () => {

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)

                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].accident_calculation_id, label: arr.data[k].accident_calculation_name })
                    }
                    self.setState({ optionCalculation: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()

        fd.append("command", "get_accident_calculation")
        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.send(fd)
    }

    saveNewPriceAccident = () => {
        const {
            accident_price_min_age,
            accident_price_max_age,
            accident_price_age_percentage,
            accident_price_disc,
            accident_price_amount,
            accident_price_urldesc,
            accident_price_desc,
            selectedCompany,
            selectedFranchise,
            // selectedMainCovarage,
            selectedSideCovarage,
            selectedJobClass,
            selectedCalculation,
            accident_price_deactive,
        } = this.state
        console.log("sasasa",selectedCalculation)

        if (selectedCompany !== "" &&
            selectedJobClass !== "" && accident_price_disc !== "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })


            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    // console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getPriceAccident()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_accident_price")

            fd.append("accident_price_fieldcompany_id", selectedCompany.value)
            fd.append("therapy_price_franchise_id", selectedFranchise.value)
            // fd.append("accident_price_accident_main_coverage_id", selectedMainCovarage.value)
            // fd.append("accident_price_accident_side_coverage_id", selectedSideCovarage.value)
            fd.append("accident_price_accident_job_class_id", selectedJobClass.value)
            fd.append("accident_calculation_id", selectedCalculation.value)
            // fd.append("accident_price_min_age", accident_price_min_age)
            // fd.append("accident_price_max_age", accident_price_max_age)
            // fd.append("accident_price_age_percentage", accident_price_age_percentage)
            fd.append("accident_price_disc", accident_price_disc)
            fd.append("accident_price_amount", accident_price_amount)
            fd.append("accident_price_urldesc", accident_price_urldesc)
            fd.append("accident_price_desc", accident_price_desc)
            fd.append("accident_price_deactive", accident_price_deactive)

            xhttp.open("POST", `${constants.BASE_URL}/Accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    saveNewPriceAccidentOld = () => {
        const { accident_price_id, accident_price_age_min, accident_price_age_max, accident_price_age_price } = this.state
        if ((accident_price_age_min != "" || accident_price_age_max != "") && accident_price_age_price != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)

                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        self.setState({ accident_price_age_price: "", accident_price_age_min: "", accident_price_age_max: "" })
                        self.getaccidentAge(accident_price_id)
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_price_age")
            fd.append("accident_price_age_accident_price_id", accident_price_id)
            fd.append("accident_price_age_price", accident_price_age_price)
            fd.append("accident_price_age_min", accident_price_age_min)
            fd.append("accident_price_age_max", accident_price_age_max)

            xhttp.open("POST", `${constants.BASE_URL}/accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }


    saveNewPriceSideCov = () => {
        const { accident_price_id, accident_price_side_coverage_price, selectedSideCovarage } = this.state
        if ((accident_price_id != "" || accident_price_side_coverage_price != "") && selectedSideCovarage.value != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })
            const { accident_price_id } = this.state

            console.log('accident_price_id',accident_price_id)
            console.log('selectedSideCovarage',selectedSideCovarage)



            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)

                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        self.setState({accident_price_side_coverage_price: "", selectedSideCovarage: "" })
                        self.getAccidentPriceSideCov(accident_price_id,selectedSideCovarage.value)
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_price_side_cov")
            fd.append("accident_price_side_coverage_accident_price_id", accident_price_id)
            fd.append("accident_price_side_coverage_price", accident_price_side_coverage_price)
            fd.append("accident_price_side_coverage_accident_side_coverage_id", selectedSideCovarage.value)

            xhttp.open("POST", `${constants.BASE_URL}/accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }






    saveNewPriceAccidentAge = () => {
        const { accident_price_id, selectedTherapyAge, therapy_price_age_price } = this.state
        if (selectedTherapyAge != "" && therapy_price_age_price != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    // console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        self.setState({ therapy_price_age_price: "", selectedTherapyAge: "" })
                        self.gettherapyAge(accident_price_id)
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_price_age")
            fd.append("therapy_price_age_accident_price_id", accident_price_id)
            fd.append("therapy_price_age_price", therapy_price_age_price)
            fd.append("therapy_price_age_therapy_age_id", selectedTherapyAge.value)

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    changePriceAccident2 = () => {
        const {
            accident_price_id,
            accident_price_urldesc,
            accident_price_desc,
            accident_price_disc,
            accident_price_amount,
            accident_price_min_age,
            accident_price_max_age,
            accident_price_age_percentage,
            selectedCompany,
            // selectedMainCovarage,
            selectedSideCovarage,
            selectedJobClass,
            selectedCalculation,
            accident_price_deactive,
        } = this.state;

        if (
            selectedCompany && accident_price_disc &&
           selectedJobClass

        ) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            });

            const self = this;
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const arr = JSON.parse(this.responseText);
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" });

                        self.getPriceAccident(); // بروزرسانی لیست پس از آپدیت

                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" });
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    });
                }
            };


            const fd = new FormData();
            fd.append("command", "modify_accident_price");
            fd.append("accident_price_id", accident_price_id);
            fd.append("accident_price_fieldcompany_id", selectedCompany.value);
            // fd.append("accident_price_accident_main_coverage_id", selectedMainCovarage.value);
            // fd.append("accident_price_accident_side_coverage_id", selectedSideCovarage.value);
            fd.append("accident_price_accident_job_class_id", selectedJobClass.value);
            fd.append("accident_calculation_id", selectedCalculation.value);
            fd.append("accident_price_urldesc", accident_price_urldesc || '');
            fd.append("accident_price_desc", accident_price_desc || '');
            fd.append("accident_price_disc", accident_price_disc || '');
            fd.append("accident_price_amount", accident_price_amount || '');
            // fd.append("accident_price_max_age", accident_price_max_age || '');
            // fd.append("accident_price_min_age", accident_price_min_age || '');
            // fd.append("accident_price_age_percentage", accident_price_age_percentage || '');
            fd.append("accident_price_deactive", accident_price_deactive);

            xhttp.open("POST", `${constants.BASE_URL}/Accident`, true);
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
            xhttp.send(fd);
        } else {
            this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" });
        }




    };


    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangeDisc = (event) => {
        this.setState({ accident_price_disc: event })
    }
    handleChangeAmount = (event) => {
        this.setState({ accident_price_amount: event })
    }
    handleChangeMinAge = (event) => {
        this.setState({ accident_price_min_age: event })
    }
    handleChangeMaxAge = (event) => {
        this.setState({ accident_price_max_age: event })
    }
    handleChangeAgePercentage = (event) => {
        this.setState({ accident_price_age_percentage: event })
    }

    handleChangUrlDesc = (event) => {
        this.setState({ accident_price_urldesc: event.target.value })
    }
    handleChangeDesc = (event) => {
        this.setState({ accident_price_desc: event.target.value })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }
    filterPriceAccident = () => {
        const { selectedCompany, requestinfos } = this.state;

        // بررسی مقادیر ورودی
        console.log('Selected Company Value:', selectedCompany.value);
        console.log('Request Infos:', requestinfos);

        // فیلتر کردن داده‌ها
        var temparray = requestinfos,
            temparray2 = [],
            i;

        for (i = 0; i < temparray.length; i++) {
            if (selectedCompany.value === 0 || temparray[i].accident_price_fieldcompany_id === selectedCompany.value) {
                temparray2.push(temparray[i]);
            }
        }

        // بررسی داده‌های فیلتر شده
        console.log('Filtered Data:', temparray2);

        // به‌روزرسانی وضعیت (state)
        this.setState({ agentInfofilter: temparray2 }, () => {
            console.log('State Updated:', this.state.agentInfofilter);
        });
    }

    render() {
        const { classes } = this.props
        const {
            accident_price_side_coverage_price,
            accident_price_age_price,
            accident_price_age_min,
            accident_price_age_max,
            accidentAges,
            accidentSides,
            therapy_price_baseinsurer_percent,
            therapy_price_age_price,
            accident_price_urldesc,
            accident_price_desc,
            accident_price_disc,
            accident_price_amount,
            accident_price_min_age,
            accident_price_max_age,
            accident_price_age_percentage,
            selectedTherapyAge,
            selectedTherapyInsurer,
            optionCompany,
            optionTherapyInsurer,
            optionTherapyAge,
            optionFranchise,
            optionMainCovarage,
            optionSideCovarage,
            optionJobClass,
            therapyInsurer,
            therapyAge,
            snackMode,
            snackstr,
            showSnack,
            newPriceAccident,
            accident_price_id,
            company_logo_url,
            selectedCompany,
            selectedFranchise,
            selectedMainCovarage,
            selectedSideCovarage,
            selectedJobClass,
            selectedCalculation,
            accident_price_deactive,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            optionCalculation,
            rowsPerPage,
            page,
        } = this.state
        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <Typography align="center" variant="h7">
                                                {"شماره قیمت بیمه درمان: " + accident_price_id}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={6}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                {/*<img alt="" className={classes.large} src={this.state.selectedCompany.logo} />*/}
                                            </div>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">شرکت بیمه</label>
                                                <Select
                                                    isSearchable={true}
                                                    className="adapter-txtsize"
                                                    placeholder={"شرکت بیمه"}
                                                    value={selectedCompany}
                                                    onChange={this.handleCompany}
                                                    options={optionCompany}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">طبقه شغلی </label>
                                                <Select
                                                    isSearchable={true}
                                                    className="adapter-txtsize"
                                                    placeholder={"طبقه شغلی"}
                                                    value={selectedJobClass}
                                                    onChange={this.handleJobClass}
                                                    options={optionJobClass}
                                                />
                                            </div>
                                        </Grid>

                                        {/*<Grid item xs={6}>*/}
                                        {/*    <div>*/}
                                        {/*        <label className="on">پوشش اصلی حوادث </label>*/}
                                        {/*        <Select*/}
                                        {/*            isSearchable={true}*/}
                                        {/*            className="adapter-txtsize"*/}
                                        {/*            placeholder={"پوشش اصلی حوادث"}*/}
                                        {/*            value={selectedMainCovarage}*/}
                                        {/*            onChange={this.handleMainCovarage}*/}
                                        {/*            options={optionMainCovarage}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</Grid>*/}
                                        {/*<Grid item xs={6}>*/}
                                        {/*    <div>*/}
                                        {/*        <label className="on">پوشش فرعی حوادث </label>*/}
                                        {/*        <Select*/}
                                        {/*            isSearchable={true}*/}
                                        {/*            className="adapter-txtsize"*/}
                                        {/*            placeholder={"پوشش فرعی حوادث"}*/}
                                        {/*            value={selectedSideCovarage}*/}
                                        {/*            onChange={this.handleSideCovarage}*/}
                                        {/*            options={optionSideCovarage}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</Grid>*/}
                                        {/*<Grid item xs={4}>*/}

                                        {/*    <FloatingLabelInput*/}
                                        {/*        type="number"*/}
                                        {/*        placeholder="از سن :"*/}
                                        {/*        handleInputt={this.handleChangeMinAge}*/}
                                        {/*        value={accident_price_min_age}*/}
                                        {/*    />*/}
                                        {/*</Grid>*/}
                                        {/*<Grid item xs={4}>*/}

                                        {/*    <FloatingLabelInput*/}
                                        {/*        type="number"*/}
                                        {/*        placeholder="تا سن :"*/}
                                        {/*        handleInputt={this.handleChangeMaxAge}*/}
                                        {/*        value={accident_price_max_age}*/}
                                        {/*    />*/}
                                        {/*</Grid>*/}
                                        {/*<Grid item xs={4}>*/}

                                        {/*    <FloatingLabelInput*/}
                                        {/*        type="percent"*/}
                                        {/*        placeholder="درصد :"*/}
                                        {/*        handleInputt={this.handleChangeAgePercentage}*/}
                                        {/*        value={accident_price_age_percentage}*/}
                                        {/*    />*/}
                                        {/*</Grid>*/}

                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                type="percent"
                                                placeholder="تخفیف"
                                                handleInputt={this.handleChangeDisc}
                                                value={accident_price_disc}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                placeholder="لینک"
                                                handleInputt={this.handleChangUrlDesc}
                                                value={accident_price_urldesc}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                type="number"
                                                placeholder="قیمت"
                                                handleInputt={this.handleChangeAmount}
                                                value={accident_price_amount}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">نحوه محاسبه </label>
                                                <Select
                                                    placeholder={"نحوه محاسبه"}
                                                    value={selectedCalculation}
                                                    onChange={this.handleCalculation}
                                                    options={optionCalculation}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FloatingLabelInput
                                                placeholder="توضیحات"
                                                handleInputt={this.handleChangeDesc}
                                                value={accident_price_desc}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={accident_price_deactive === "0" ? true : false}
                                                            onChange={this.handleChangeDeactive}
                                                            name="gilad"
                                                        />
                                                    }
                                                    label="وضعیت قیمت شرکت بیمه"
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            {newPriceAccident ? (
                                                <Button variant="outlined" color="primary" onClick={this.saveNewPriceAccident}>
                                                    {"ثبت قیمت بیمه درمان جدید "}
                                                </Button>
                                            ) : (
                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.newPriceAccident}
                                                    >
                                                        {"قیمت بیمه درمان جدید "}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.changePriceAccident2}
                                                    >
                                                        {"ثبت تغییرات"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.handleClickOpen()
                                                        }}
                                                    >
                                                        {" حذف قیمت بیمه درمان"}
                                                    </Button>
                                                </div>
                                            )}
                                        </Grid>

                                        {newPriceAccident ? null : (
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>

                        {/*<Grid item xs={12}>*/}
                        {/*    <Container>*/}
                        {/*        <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>*/}
                        {/*            {newPriceAccident ? null : (*/}
                        {/*                <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>*/}
                        {/*                    {therapyAge.map((therapyAge, index) => (*/}
                        {/*                        <TherapyAge therapyAge={therapyAge} props={this.props} key={index} />*/}
                        {/*                    ))}*/}
                        {/*                </Grid>*/}
                        {/*            )}*/}
                        {/*        </Paper>*/}


                        {/*                <Paper className={classes.root}>*/}
                        {/*                    {newPriceAccident ? null : (*/}
                        {/*                        <Grid item xs={12}>*/}
                        {/*                            <Grid container spacing={3}>*/}
                        {/*                                <Grid item xs={3}>*/}
                        {/*                                    <FloatingLabelInput*/}
                        {/*                                        type="number"*/}
                        {/*                                        placeholder="از سن"*/}
                        {/*                                        handleInputt={this.handleSlidePriceOldMin}*/}
                        {/*                                        value={accident_price_age_min}*/}
                        {/*                                    />*/}
                        {/*                                </Grid>*/}
                        {/*                                <Grid item xs={3}>*/}
                        {/*                                    <FloatingLabelInput*/}
                        {/*                                        type="number"*/}
                        {/*                                        placeholder="تا سن"*/}
                        {/*                                        handleInputt={this.handleSlidePriceOldMax}*/}
                        {/*                                        value={accident_price_age_max}*/}
                        {/*                                    />*/}
                        {/*                                </Grid>*/}

                        {/*                                <Grid item item xs={3}>*/}
                        {/*                                    <FloatingLabelInput*/}
                        {/*                                        type="number"*/}
                        {/*                                        placeholder="درصد"*/}
                        {/*                                        handleInputt={this.handleChangeSlideOldPercent}*/}
                        {/*                                        value={accident_price_age_price}*/}
                        {/*                                    />*/}
                        {/*                                </Grid>*/}

                        {/*                                <Grid item item xs={3}>*/}
                        {/*                                    <div style={{ width: "100%", textAlign: "left" }}>*/}
                        {/*                                        <Fab*/}
                        {/*                                            className={classes.small}*/}
                        {/*                                            color="primary"*/}
                        {/*                                            aria-label="add"*/}
                        {/*                                            onClick={this.saveNewPriceAccidentOld}*/}
                        {/*                                        >*/}
                        {/*                                            <AddIcon />*/}
                        {/*                                        </Fab>*/}
                        {/*                                    </div>*/}
                        {/*                                </Grid>*/}
                        {/*                            </Grid>*/}
                        {/*                        </Grid>*/}
                        {/*                    )}*/}
                        {/*                </Paper>*/}
                        {/*    </Container>*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={12}>*/}
                        {/*    <Container>*/}
                        {/*        <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>*/}
                        {/*            {newPriceAccident ? null : (*/}
                        {/*                <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>*/}
                        {/*                    {therapyInsurer.map((therapyInsurer, index) => (*/}
                        {/*                        <TherapyInsurer*/}
                        {/*                            therapyInsurer={therapyInsurer}*/}
                        {/*                            props={this.props}*/}
                        {/*                            key={index}*/}
                        {/*                        />*/}
                        {/*                    ))}*/}
                        {/*                </Grid>*/}
                        {/*            )}*/}
                        {/*        </Paper>*/}
                        {/*        <Paper className={classes.root}>*/}
                        {/*            {newPriceAccident ? null : (*/}
                        {/*                <Grid item xs={12}>*/}
                        {/*                    <Grid container spacing={3}>*/}
                        {/*                        <Grid item xs={5}>*/}
                        {/*                            <div>*/}
                        {/*                                <label className="on">بیمه گر پایه </label>*/}
                        {/*                                <Select*/}
                        {/*                                    isSearchable={true}*/}
                        {/*                                    className="adapter-txtsize"*/}
                        {/*                                    placeholder={"بیمه گر پایه"}*/}
                        {/*                                    value={selectedTherapyInsurer}*/}
                        {/*                                    onChange={this.handleTherapyInsurer}*/}
                        {/*                                    options={optionTherapyInsurer}*/}
                        {/*                                />*/}
                        {/*                            </div>*/}
                        {/*                        </Grid>*/}

                        {/*                        <Grid item item xs={4}>*/}
                        {/*                            <FloatingLabelInput*/}
                        {/*                                type="percent"*/}
                        {/*                                placeholder=" درصد اضافه نرخ "*/}
                        {/*                                handleInputt={this.handleChangeTherapyInsurer}*/}
                        {/*                                value={therapy_price_baseinsurer_percent}*/}
                        {/*                            />*/}
                        {/*                        </Grid>*/}

                        {/*                        <Grid item item xs={3}>*/}
                        {/*                            <div style={{ width: "100%", textAlign: "left" }}>*/}
                        {/*                                <Fab*/}
                        {/*                                    className={classes.small}*/}
                        {/*                                    color="primary"*/}
                        {/*                                    aria-label="add"*/}
                        {/*                                    onClick={this.saveNewPriceAccidentInsurer}*/}
                        {/*                                >*/}
                        {/*                                    <AddIcon />*/}
                        {/*                                </Fab>*/}
                        {/*                            </div>*/}
                        {/*                        </Grid>*/}
                        {/*                    </Grid>*/}
                        {/*                </Grid>*/}
                        {/*            )}*/}
                        {/*        </Paper>*/}
                        {/*    </Container>*/}
                        {/*</Grid>*/}

                        <Grid item xs={12} sm={12}>
                            <Container>
                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                    {newPriceAccident ? null : (
                                        <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                            {accidentAges.map((accidentAge, index) => (
                                                <AccidentAge
                                                    accidentAge={accidentAge}
                                                    props={this.props}
                                                    key={index}
                                                />
                                            ))}
                                        </Grid>
                                    )}
                                </Paper>
                                <Paper className={classes.root}>
                                    {newPriceAccident ? null : (
                                        <Grid item xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={3}>
                                                    <FloatingLabelInput
                                                        type="number"
                                                        placeholder="از سن"
                                                        handleInputt={this.handleSlidePriceOldMin}
                                                        value={accident_price_age_min}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <FloatingLabelInput
                                                        type="number"
                                                        placeholder="تا سن"
                                                        handleInputt={this.handleSlidePriceOldMax}
                                                        value={accident_price_age_max}
                                                    />
                                                </Grid>

                                                <Grid item item xs={3}>
                                                    <FloatingLabelInput
                                                        type="number"
                                                        placeholder="درصد"
                                                        handleInputt={this.handleChangeSlideOldPercent}
                                                        value={accident_price_age_price}
                                                    />
                                                </Grid>

                                                <Grid item item xs={3}>
                                                    <div style={{ width: "100%", textAlign: "left" }}>
                                                        <Fab
                                                            className={classes.small}
                                                            color="primary"
                                                            aria-label="add"
                                                            onClick={this.saveNewPriceAccidentOld}
                                                        >
                                                            <AddIcon />
                                                        </Fab>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Paper>

                            </Container>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <Container>
                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                    {newPriceAccident ? null : (
                                        <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                            {accidentSides.map((AccidentSideCovPriceData, index) => (
                                                <AccidentSideCovPrice
                                                    AccidentSideCovPriceData={AccidentSideCovPriceData}
                                                    optionSideCovarage={optionSideCovarage}
                                                    props={this.props}
                                                    key={index}
                                                />
                                            ))}




                                        </Grid>
                                    )}
                                </Paper>
                                <Paper className={classes.root}>
                                    {newPriceAccident ? null : (
                                        <Grid item xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={6}>
                                                    <div>
                                                        <label className="on">پوشش فرعی حوادث </label>
                                                        <Select
                                                            isSearchable={true}
                                                            className="adapter-txtsize"
                                                            placeholder={"پوشش فرعی حوادث"}
                                                            value={selectedSideCovarage}
                                                            onChange={this.handleSideCovarage}
                                                            options={optionSideCovarage}
                                                        />
                                                    </div>
                                                </Grid>

                                                <Grid item item xs={3}>
                                                    <FloatingLabelInput
                                                        type="percent"
                                                        placeholder="درصد"
                                                        handleInputt={this.handleChangeSideCoveragePrice}
                                                        value={accident_price_side_coverage_price}
                                                    />
                                                </Grid>

                                                <Grid item item xs={3}>
                                                    <div style={{ width: "100%", textAlign: "left" }}>
                                                        <Fab
                                                            className={classes.small}
                                                            color="primary"
                                                            aria-label="add"
                                                            onClick={this.saveNewPriceSideCov}
                                                        >
                                                            <AddIcon />
                                                        </Fab>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Paper>

                            </Container>
                        </Grid>



                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"accident_price_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "accident_price_id" ? order : false}
                                                    >
                                                        {" آی دی "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_price_id"}
                                                            direction={orderBy === "accident_price_id" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_price_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"company_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه  "}
                                                        <TableSortLabel
                                                            active={orderBy === "company_name"}
                                                            direction={orderBy === "company_name" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("company_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    {/*<TableCell*/}
                                                    {/*    key={"accident_price_accident_main_coverage_id"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"پوشش اصلی حوادث "}*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "accident_price_accident_main_coverage_id"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "accident_price_accident_main_coverage_id"*/}
                                                    {/*                ? order*/}
                                                    {/*                : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("accident_price_accident_main_coverage_id")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}

                                                    <TableCell
                                                        key={"accident_price_accident_job_class_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"طبقه شغلی "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_price_accident_job_class_id"}
                                                            direction={
                                                                orderBy === "accident_price_accident_job_class_id"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_price_accident_job_class_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"accident_price_disc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تخفیف"}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_price_disc"}
                                                            direction={orderBy === "accident_price_disc" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_price_disc")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"accident_price_amount"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"قیمت"}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_price_amount"}
                                                            direction={orderBy === "accident_price_amount" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_price_amount")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                    <TableCell
                                                        key={"accident_price_deactive"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                    >
                                                        {"وضعیت قیمت بیمه درمان"}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_price_deactive"}
                                                            direction={
                                                                orderBy === "accident_price_deactive" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_price_deactive")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>


                                            <TableBody>
                                                {/*{console.log("Data in TableBody:", this.state.agentInfofilter)}*/}



                                                {agentInfofilter.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)


                                                    .map((row) => {



                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["accident_price_id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.handleSelectRows(row)
                                                                }}
                                                            >
                                                                <TableCell key={"accident_price_id"} align={"center"}>
                                                                    {row["accident_price_id"]}
                                                                </TableCell>

                                                                <TableCell key={"company_name"} align={"center"}>
                                                                    {row["company_name"]}
                                                                    <img
                                                                        className={classes.small}
                                                                        alt="Remy Sharp"
                                                                        src={row["company_logo_url"]}
                                                                    />
                                                                </TableCell>

                                                                {/*<TableCell*/}
                                                                {/*    key={"accident_price_accident_main_coverage_id"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["accident_main_coverage_name"]}*/}
                                                                {/*</TableCell>*/}
                                                                {/*<TableCell*/}
                                                                {/*    key={"accident_price_accident_side_coverage_id"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["accident_side_coverage_name"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"accident_price_accident_job_class_id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_job_class_name"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"accident_price_disc"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_price_disc"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"accident_price_amount"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_price_amount"]}
                                                                </TableCell>

                                                                {/*<TableCell*/}
                                                                {/*    key={"accident_price_min_age"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["accident_price_min_age"]}*/}
                                                                {/*</TableCell>*/}
                                                                {/*<TableCell*/}
                                                                {/*    key={"accident_price_max_age"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["accident_price_max_age"]}*/}
                                                                {/*</TableCell>*/}
                                                                {/*<TableCell*/}
                                                                {/*    key={"accident_price_age_percentage"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["accident_price_age_percentage"]}*/}
                                                                {/*</TableCell>*/}

                                                                <TableCell
                                                                    key={"accident_price_deactive"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_price_deactive"] === "1"? (
                                                                        <Fab variant="extended">
                                                                            <VoiceOverOffIcon />
                                                                            {"غیر فعال"}
                                                                        </Fab>
                                                                    ) : (
                                                                        <Fab
                                                                            variant="extended"
                                                                            style={{ background: "#44b700" }}
                                                                        >
                                                                            <RecordVoiceOverIcon />
                                                                            {"فعال"}
                                                                        </Fab>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                    <Dialog
                        open={this.state.openDialog}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه درمان را حذف نمایید"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                انصراف
                            </Button>
                            <Button onClick={this.deletePriceAccident} color="primary" autoFocus>
                                بله انجام شود
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )
        }
    }
}

export default withStyles(styles)(ChangePriceAccident)
